(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Suggestions', Suggestions);

    Suggestions.$inject = ['$http'];

    function Suggestions($http) {

        var service = {
            get : get
        };

        return service;

        function get(count) {
            if (!angular.isNumber(count)) {
                count = 8;
            }
            return $http.get('api/profiles/suggestions/' + count).then(function (res) {
                if (res && res.data) {
                    return res.data;
                }
            });
        }
    }
})();
